import { $ } from '../utils/jquery.js';

export const HIDDEN = "dropdown/shown";
export const SHOWN = "dropdown/hidden";
export const BEFORE_SHOW = "dropdown/beforeshow";
export const BEFORE_HIDE = "dropdown/beforehide";

/**
 *
 * @param {jQuery Element} dropdown
 * @param {Boolean} show
 */

function hideOnClickOutside(selector, callback) {
  const outsideClickListener = (event) => {
    const $target = $(event.target);
    if (!$target.closest(selector).length && selector.hasClass("is-active")) {
      callback();
      removeClickListener();
    }
  };

  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };

  document.addEventListener("click", outsideClickListener);
}

const toggle = (dropdown, show = true) => {
  if (!dropdown.length) {
    return;
  }

  const event = [BEFORE_HIDE, BEFORE_SHOW][Number(show)];
  const btn = dropdown.prev();

  if (btn.hasClass("js-dropdown-toggle")) {
    btn.toggleClass("is-active", show);
  }

  dropdown.trigger(event).toggleClass("is-active", show);

  if (show) {
    hideOnClickOutside(dropdown, () => {
      toggle(dropdown, false);
    });
  }
};

$(document).on("click", ".js-dropdown-toggle", function (e) {
  const btn = $(this);
  const dropdown = btn.next();

  if (!dropdown.hasClass("js-dropdown")) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  jQuery(dropdown).toggleClass('is-active');//, !btn.hasClass("is-active"));
});

/**
 * Trigger shown/hidden event, after transition end
 */
$(document).on("transitionend", ".js-dropdown", function () {
  const self = $(this);
  const isActive = Number(self.hasClass("is-active"));

  self.trigger([HIDDEN, SHOWN][isActive]);
});

/**
 * Hide all visible dropdown before to show new one
 */
$(document).on(BEFORE_SHOW, ".js-dropdown", () => {
  $(".js-dropdown.is-active").each(function () {
    toggle($(this), false);
  });
});
